// Old notification link_tab values that name no screen. Alerts already in the
// bell, and push/email links already sent, still carry them; a tab id with no
// screen renders a blank page (CJ 2026-10-23: an incident alert opened blank).
// Maps each to the screen that handles it.
const ALIASES = {
  incidents: (isManager) => (isManager ? 'reports-incidents' : 'report-incident'),
  'admin-team': () => 'team',
};

export function resolveTabAlias(tab, isManager) {
  const to = ALIASES[tab];
  return to ? to(!!isManager) : tab;
}

export const LEGACY_TAB_ALIASES = Object.keys(ALIASES);
